import composer from './journey-composer';
import reporting from './journey-report';

export default {
    namespaced: true,
    modules: {
        composer,
        reporting
    }
};
